class LayoutLoading {
	static instance;
	loadingInfo = reactive({
		isLoading: false,
		message: '',
	});

	constructor() {
		if (!LayoutLoading.instance) {
			LayoutLoading.instance = this;
		}
		return LayoutLoading.instance;
	}

	setLoading(value) {
		if (!value) {
			setTimeout(() => {
				this.loadingInfo.message = '';
				this.loadingInfo.isLoading = value;
			}, 500);

			return;
		}
		this.loadingInfo.isLoading = value;
	}

	setMessage(value) {
		this.loadingInfo.message = value;
	}
}

export default new LayoutLoading();
